import { alpha, Box, styled } from '@mui/material'

export const VIEW_LIST_ROW_SPACING_VAR = '--DinoViewList-rowSpacing'

export const viewListClasses = {
  root: 'DinoViewList-root',
  normal: 'DinoViewList-normal',
  virtualized: 'DinoViewList-virtualized',
  autoHeight: 'DinoViewList-autoHeight',
  scrollContainer: 'DinoViewList-scrollContainer',
  table: 'DinoViewList-table',
  tableHeader: 'DinoViewList-tableHeader',
  tableHeaderCell: 'DinoViewList-tableHeaderCell',
  tableBodyCell: 'DinoViewList-tableBodyCell',
  tableSpacerRow: 'DinoViewList-tableSpacerRow',
  tableSpacerCell: 'DinoViewList-tableSpacerCell',
  tableCellContent: 'DinoViewList-tableCellContent'
}
const classes = viewListClasses

export const ViewListStyled = styled(Box)(({ theme }) => {
  const mode = theme.palette.mode
  const borderColor = alpha(theme.palette.common.black, mode === 'dark' ? 0.24 : 0.08)
  const bgHeader = mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[50]

  return {
    [`&.${classes.root}`]: {
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'hidden'
    },
    [`.${classes.scrollContainer}`]: {
      position: 'absolute',
      inset: 0, // top: 0, left: 0, right: 0, bottom: 0
      overflowY: 'auto',
      overflowX: 'auto',
      overflowAnchor: 'none',
      // Scrollbar styling
      '&::-webkit-scrollbar': { width: 6, height: 6 },
      '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.grey[400] },
      '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.grey[600] },
      '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.grey[200], borderRadius: 4 },
      '&::-webkit-scrollbar-track:hover': { backgroundColor: theme.palette.grey[300] }
    },
    [`.${classes.table}`]: {
      tableLayout: 'fixed',
      width: '100%',
      borderCollapse: 'separate',
      borderSpacing: `0 var(${VIEW_LIST_ROW_SPACING_VAR}, ${theme.spacing(0.5)})`,
      marginTop: `calc(var(${VIEW_LIST_ROW_SPACING_VAR}, ${theme.spacing(0.5)}) * -1)`
    },
    [`.${classes.tableHeader}`]: {
      position: 'sticky',
      top: 0,
      zIndex: 2,
      backgroundColor: bgHeader
    },
    [`.${classes.tableHeaderCell}`]: {
      fontWeight: 500,
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      overflow: 'hidden',
      borderBottom: 'unset'
      // borderTop: `1px dashed ${borderColor}`,
      // borderBottom: `1px dashed ${borderColor}`,
      // '&:first-of-type': { borderLeft: `1px dashed ${borderColor}` },
      // '&:last-of-type': { borderRight: `1px dashed ${borderColor}` }
    },
    [`.${classes.tableBodyCell}`]: {
      overflow: 'hidden',
      borderTop: `0.5px dashed ${borderColor}`,
      borderBottom: `0.5px dashed ${borderColor}`,
      '&:first-of-type': {
        borderLeft: `0.5px dashed ${borderColor}`,
        borderRadius: theme.spacing(0.5, 0, 0, 0.5)
      },
      '&:last-of-type': {
        borderRight: `0.5px dashed ${borderColor}`,
        borderRadius: theme.spacing(0, 0.5, 0.5, 0)
      }
    },
    [`.${classes.tableCellContent}`]: {
      minWidth: 0, // Allow shrinking below content size
      width: '100%' // Fill parent TableCell
    },
    // Virtualized styles
    [`&.${classes.virtualized}`]: { boxSizing: 'border-box' },
    // Auto-height variant: disable the internal scroll container and let the
    // component size expand with content. This makes the table render all
    // rows and removes the internal scrollbar used in 'normal' modes.
    [`&.${classes.normal}.${classes.autoHeight}`]: {
      height: 'auto',
      overflow: 'visible',
      [`.${classes.scrollContainer}`]: {
        position: 'static',
        inset: 'auto',
        overflowY: 'visible'
      }
    }
  }
})
